import {
    type FC
} from "react";
import {
    Animated
} from "react-native";
import type IMessageActionsProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import type {
    MessagePartContentProps
} from "../../type";
import {
    withMessageContext
} from "../../context";

const MessageActionsContent: FC<MessagePartContentProps<IMessageActionsProps>> = ({
    customLocalize,
    customTheme,
    isVisible,
    children,
    context,
    style,
    title,
    ...props
}) => {
    const currentTheme = customTheme ?? context.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(currentTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize ?? context.customLocalize);

    const isShown = isVisible ?? context.isActionsVisible;

    const opacity = useAnimatedState({
        customTheme: currentTheme,
        value: isShown ? 1 : 0,
        intent: "hover"
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    return <Animated.View
        {...props}
        aria-label={title ?? localize("message-actions")}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle,
            {
                opacity
            }
        ]}
        role="toolbar"
    >
        {children}
    </Animated.View>;
};

const MessageActions = withMessageContext<IMessageActionsProps>("Actions", MessageActionsContent);
export default MessageActions;
